import * as cookie from 'cookie'

export interface CookiePreferences {
	preferences: boolean
	statistics: boolean
	marketing: boolean
}

export const COOKIE_NAME = 'tv-cookie-consent'
export const COOKIE_EXPIRY_DAYS = 365

export function getCookiePreferences(): CookiePreferences | null {
	if (typeof document === 'undefined') {
		return null
	}

	const cookies = cookie.parseCookie(document.cookie)
	const consent = cookies[COOKIE_NAME]

	if (consent) {
		try {
			return JSON.parse(consent) as CookiePreferences
		} catch (error) {
			console.error('Failed to parse cookie preferences:', error)
		}
	}
	return null
}
